import * as React from 'react';

import logger from 'js/app/loggerSingleton';

import DegreeCollectionComponent from 'bundles/browse-common/components/DegreeCollectionComponent';
import { useDegreeCollection } from 'bundles/browse-common/contexts/DegreeCollectionContext';
import { usePageConfigComponentMetadata } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';

const DegreeCollectionRenderer = () => {
  const degreeCollectionContext = useDegreeCollection();
  const pageConfigComponentMetadataContext = usePageConfigComponentMetadata();

  if (!degreeCollectionContext) {
    logger.warn('DegreeCollectionRenderer expected DegreeCollectionProvider');
    return null;
  }
  if (!pageConfigComponentMetadataContext) {
    logger.warn('DegreeCollectionRenderer expected PageConfigComponentMetadataProvider');
    return null;
  }

  const { collectionSet, isLoading } = degreeCollectionContext;
  const { index, id, name } = pageConfigComponentMetadataContext;

  return (
    <DegreeCollectionComponent
      collectionSet={collectionSet}
      isLoading={isLoading}
      showPageTitleHeadingSize={index === 0}
      pageConfigComponentTrackingData={{ id, name: name ?? '', index }}
    />
  );
};

export default DegreeCollectionRenderer;
